import { useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import image from 'resources/shutterstock_691534279.jpg';
import { readQuery } from 'utils/helpers';
import { useUnsubscribeEmail } from 'hooks';
import { ThemeContext } from 'contexts/themeContext';
import { Alert, AlertIcon, AlertTitle, Button } from 'components/UI';
import { base2ColourGradient } from 'constants/theme';
import { PageTitle } from 'components/common/PageTitle';

const Unsubscribe = () => {
  const location = useLocation();

  const queryParams = location ? readQuery(location) : null;

  const [unsubscribed, setUnsubscribed] = useState(false);

  const [unsubscribeEmail] = useUnsubscribeEmail();

  let renderContent = <Text>No unsubscribe email provided.</Text>;

  const handleUnsubscribe = () => {
    if (!queryParams?.email) return;

    setUnsubscribed(true);

    unsubscribeEmail(queryParams.email as string);
  };

  const renderTitle = !unsubscribed && queryParams?.email ? <PageTitle mb={4}>Unsubscribe</PageTitle> : null;

  if (queryParams?.email) {
    renderContent = unsubscribed ? (
      <Box>
        <Alert
          flexDirection="column"
          alignItems="center"
          status="success"
          justifyContent="center"
          bgColor="transparent"
        >
          <AlertIcon mb={2} boxSize={14} mr={0} color="primaryThemeColour.400" />
          <AlertTitle mb={2} color="black">
            Unsubscribed Successfully.
          </AlertTitle>
        </Alert>
        <Text maxW={500}>
          The email&nbsp;
          <Text as="span" fontWeight="medium">
            {queryParams.email as string}
          </Text>
          &nbsp;has been unsubscribed from further email communications.
        </Text>
      </Box>
    ) : (
      <Box textAlign="center">
        <Text mb={5}>Are you sure you want to unsubscribe from all email communications?</Text>
        <Button onClick={handleUnsubscribe}>CONFIRM</Button>
      </Box>
    );
  }

  return (
    <ThemeContext.Consumer>
      {() => (
        <Box
          data-testid="unsubscribe-page"
          sx={{
            bgColor: 'gray.200',
            bgImage: `url(${image})`,
            w: 'full',
            bgSize: '2000px 1000px',
          }}
        >
          <Flex
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              w: 'full',
              bg: base2ColourGradient,
              height: '100vh',
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                bgColor: 'white',
                p: 8,
                pb: queryParams?.email ? 12 : 8,
                borderRadius: 6,
              }}
            >
              {renderTitle}
              {renderContent}
            </Box>
          </Flex>
        </Box>
      )}
    </ThemeContext.Consumer>
  );
};

export default Unsubscribe;
